module.exports = __webpack_public_path__ + "assets/img/notifications.c6d3eeb2.png";